import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { User } from '../models';
import { UserService } from '../services';

@Injectable({
  providedIn: 'root'
})
export class UserNotBeepManagerGuard implements CanActivate {
    constructor(
        private router: Router,
        private userService: UserService
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | UrlTree {
        const userIsCustomer = this.userService.userIsCustomer();

        if (!userIsCustomer) {
            return of(true);
        }
        return this.router.createUrlTree(['/customer/']);
    }

}
